export default  [
  'lifeSat',
  'worthwhile',
  'happiness',
  'anxious',
  'hopeFuture',
  'fairTreatment',
  'satisRship',
  'satisSocial',
  'relyOn',
  'loneliness',
  'commInt',
  'trustOthers',
  'lifeExpect',
  'satisHealth',
  'healthstat',
  'physicalHealth',
  'depressionAnxiety',
  'satisHealthcare',
  'satisTime',
  'satisJob',
  'unpaidWork',
  'volunteering',
  'artsCulture',
  'sportsPart',
  'nature',
  'satisAccomm',
  'satisLocal',
  'belongNeigh',
  'digitalEx',
  'crime',
  'feelingSafe',
  'hholdIncome',
  'hholdWealth',
  'lowIncome',
  'incomeInequal',
  'genderPaygap',
  'diffFinance',
  'neet',
  'noQuals',
  'alevelQuals',
  'humanCapital',
  'satisSkills',
  'satisEducation',
  'unemployment',
  'inflation',
  'GDP',
  'publicsecDebt',
  'consumerConf',
  'voterTurnout',
  'trustGov',
  'voice',
  'satisPolice',
  'satisCourts',
  'greenhouseGas',
  'renewableEnergy',
  'hholdRecycling',
  'protectedArea',
  'biodiversity',
  'airPoll',
  'waterPoll',
  'envLifestyle']